// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","wrap":"Layout_wrap__WHN0h","sidebarOpen":"Layout_sidebarOpen__1xwjM","content":"Layout_content__UOgH6","sidebarBackdrop":"Layout_sidebarBackdrop__6Wn5d"};